import { convertThenFormat } from "../../../components/common-data/Converts";

export const tbAllMembersColumns = [
  {
    dataField: "name",
    text: <p className="table__header">User Name</p>,
    formatter: (cell, row) => <p>{row?.name}</p>,
  },

  {
    dataField: "total_earn",
    text: <p className="table__header">Total Coins Earned</p>,
    formatter: (cell, row) => <p>{row?.total_earn}</p>,
  },
  {
    dataField: "total_earn",
    text: <p className="table__header">Toal Earn</p>,
    formatter: (cell, row) => <p>{row?.total_earn}</p>,
  },
  {
    dataField: "coins_inr_value",
    text: <p className="table__header">Coins Inr Value</p>,
    formatter: (cell, row) => (
      <p>{`₹${convertThenFormat(row?.coins_inr_value)}`}</p>
    ),
  },
];
